(function () {
  'use strict';

  var MAX_ARTICLES = 20;
  var MAX_IMAGE_BYTES = 1024 * 1024;
  var MAX_TOTAL_BYTES = 15 * 1024 * 1024;
  var MAX_IMAGE_DIMENSION = 1600;
  var MAX_SUGGESTIONS = 8;
  var DRAFT_SAVE_INTERVAL_MS = 2500;
  var DRAFT_DB_NAME = 'ns-submission-lead-drafts';
  var DRAFT_DB_VERSION = 1;
  var DRAFT_IMAGE_STORE = 'images';
  var DEFAULT_ENDPOINT = 'https://script.google.com/macros/s/AKfycbzYMnOl3K69zSIenutX7x-cEP4IAYp6x_W12nTzqeM2PwbY8-qOt0RYY5w9b6OxeWEm/exec';
  var STEP_ORDER = ['contact', 'articles', 'confirm'];

  function safeText(value) {
    return value === null || value === undefined ? '' : String(value);
  }

  function normalizeText(value) {
    return safeText(value).trim().toLowerCase();
  }

  function digitsOnly(value) {
    return safeText(value).replace(/\D/g, '');
  }

  function normalizePhoneNumber(countryCode, phoneNumber) {
    var country = digitsOnly(countryCode);
    var number = digitsOnly(phoneNumber);

    if (!country || !number) {
      return '';
    }

    if (number.indexOf('00') === 0) {
      number = number.slice(2);
    }

    if (number.indexOf(country) === 0) {
      return number;
    }

    if (country === '46' && number.charAt(0) === '0') {
      number = number.slice(1);
    }

    return country + number;
  }

  function isValidNormalizedPhone(value) {
    return /^[1-9][0-9]{7,14}$/.test(safeText(value));
  }

  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onload = function () {
        resolve(reader.result);
      };

      reader.onerror = function () {
        reject(new Error('Kunde inte läsa bilden.'));
      };

      reader.readAsDataURL(file);
    });
  }

  function loadImage(dataUrl) {
    return new Promise(function (resolve, reject) {
      var image = new Image();

      image.onload = function () {
        resolve(image);
      };

      image.onerror = function () {
        reject(new Error('Kunde inte förbereda bilden.'));
      };

      image.src = dataUrl;
    });
  }

  function dataUrlToBytes(dataUrl) {
    var base64 = safeText(dataUrl).split('base64,').pop() || '';
    var padding = base64.endsWith('==') ? 2 : (base64.endsWith('=') ? 1 : 0);
    return Math.floor((base64.length * 3) / 4) - padding;
  }

  function formatBytes(bytes) {
    if (bytes >= 1024 * 1024) {
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    return Math.max(1, Math.round(bytes / 1024)) + ' kB';
  }

  function isSubmissionDebugEnabled() {
    return Boolean(
      window.Shopify && window.Shopify.designMode ||
      window.location.hostname === 'localhost' ||
      window.location.search.indexOf('nsi_debug=1') !== -1
    );
  }

  function isLegacyNsPaseAccessMessage(message) {
    return /ns\s*påse\s*access/i.test(safeText(message)) ||
      /ns\s*pase\s*access/i.test(safeText(message)) ||
      /saknas\s+eller\s+är\s+ogiltig/i.test(safeText(message));
  }

  function getSubmissionErrorMessage(result, fallbackMessage) {
    var message = result && result.message ? result.message : safeText(fallbackMessage);
    var reason = result && (result.reason || result.access_reason) ? safeText(result.reason || result.access_reason) : '';

    if (isLegacyNsPaseAccessMessage(message) || reason === 'missing_access' || reason === 'invalid_access') {
      return 'Förhandsregistreringen kunde inte skickas. Kontrollera uppgifterna och försök igen.';
    }

    if (reason === 'unsupported_payload_type' || reason === 'missing_submission_lead_type') {
      return 'Förhandsregistreringen kunde inte skickas. Formuläret skickades inte som ett förhandsärende.';
    }

    return message || 'Förhandsregistreringen kunde inte skickas. Kontrollera uppgifterna och försök igen.';
  }

  async function compressImage(file) {
    var dataUrl = await readFileAsDataUrl(file);
    var image = await loadImage(dataUrl);
    var scale = Math.min(1, MAX_IMAGE_DIMENSION / Math.max(image.width, image.height));
    var canvas = document.createElement('canvas');
    var context;
    var quality = 0.82;
    var output;
    var size;

    canvas.width = Math.max(1, Math.round(image.width * scale));
    canvas.height = Math.max(1, Math.round(image.height * scale));
    context = canvas.getContext('2d');
    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    do {
      output = canvas.toDataURL('image/jpeg', quality);
      size = dataUrlToBytes(output);
      quality -= 0.08;
    } while (size > MAX_IMAGE_BYTES && quality >= 0.42);

    if (size > MAX_IMAGE_BYTES) {
      throw new Error('Bilden "' + file.name + '" är för stor även efter komprimering. Välj en mindre bild.');
    }

    return {
      filename: file.name || 'bild.jpg',
      mime_type: 'image/jpeg',
      size: size,
      data: output.split('base64,').pop()
    };
  }

  function initForm(root) {
    var form = root.querySelector('[data-ns-submission-form]');
    var countInput = root.querySelector('[data-ns-submission-count]');
    var addArticleButton = root.querySelector('[data-ns-submission-add-article]');
    var addArticleRow = root.querySelector('[data-ns-submission-article-add-row]');
    var articlesContainer = root.querySelector('[data-ns-submission-articles]');
    var articleTemplate = root.querySelector('[data-ns-submission-article-template]');
    var phoneCountryInput = root.querySelector('[data-ns-submission-phone-country]');
    var phoneInput = root.querySelector('[data-ns-submission-phone]');
    var phonePreview = root.querySelector('[data-ns-submission-phone-preview]');
    var submitButton = root.querySelector('[data-ns-submission-submit]');
    var errorNode = root.querySelector('[data-ns-submission-error]');
    var successNode = root.querySelector('[data-ns-submission-success]');
    var draftPanel = root.querySelector('[data-ns-submission-draft-panel]');
    var draftRestoreButton = root.querySelector('[data-ns-submission-draft-restore]');
    var draftClearButton = root.querySelector('[data-ns-submission-draft-clear]');
    var draftStatusNode = root.querySelector('[data-ns-submission-draft-status]');
    var draftWarningNode = root.querySelector('[data-ns-submission-draft-warning]');
    var submitStatusNode = root.querySelector('[data-ns-submission-submit-status]');
    var modalNode = root.querySelector('[data-ns-submission-modal]');
    var modalDialog = modalNode ? modalNode.querySelector('.ns-submission__modal-dialog') : null;
    var modalTitleNode = root.querySelector('[data-ns-submission-modal-title]');
    var modalCopyNode = root.querySelector('[data-ns-submission-modal-copy]');
    var modalMetaNode = root.querySelector('[data-ns-submission-modal-meta]');
    var modalNextNode = root.querySelector('[data-ns-submission-modal-next]');
    var modalProgressNode = root.querySelector('[data-ns-submission-modal-progress]');
    var modalProgressBarNode = root.querySelector('[data-ns-submission-modal-progress-bar]');
    var modalProgressLabelNode = root.querySelector('[data-ns-submission-modal-progress-label]');
    var modalProgressPercentNode = root.querySelector('[data-ns-submission-modal-progress-percent]');
    var modalActionsNode = root.querySelector('[data-ns-submission-modal-actions]');
    var successNewButton = root.querySelector('[data-ns-submission-success-new]');
    var successHomeButton = root.querySelector('[data-ns-submission-success-home]');
    var modalCloseNodes = Array.prototype.slice.call(root.querySelectorAll('[data-ns-submission-modal-close]'));
    var stepNodes = Array.prototype.slice.call(root.querySelectorAll('[data-ns-submission-step]'));
    var endpoint = root.getAttribute('data-endpoint') || DEFAULT_ENDPOINT;
    var brandsUrl = root.getAttribute('data-brands-url');
    var itemTypesUrl = root.getAttribute('data-item-types-url');
    var brandEntries = [];
    var brandLookup = Object.create(null);
    var itemTypeEntries = [];
    var itemTypeLookup = Object.create(null);
    var submitLabel = submitButton && submitButton.textContent ? submitButton.textContent.trim() : 'Skicka förfrågan';
    var draftStorageKey = 'ns_submission_lead_draft:' + window.location.pathname;
    var draftId = 'nsi-draft-' + window.location.pathname.replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '');
    var draftImages = {
      articles: {}
    };
    var imageProcessing = {
      articles: {}
    };
    var imageErrors = {
      articles: {}
    };
    var imageProcessingRuns = {
      articles: {}
    };
    var draftSaveTimer = null;
    var draftSaveInterval = null;
    var activeStep = 'Intro';
    var draftRestoreChoicePending = false;
    var isRestoringDraft = false;
    var isSubmitting = false;
    var hasSubmittedSuccessfully = false;
    var slowSubmitTimer = null;
    var submitProgressTimer = null;
    var successRedirectTimer = null;
    var successCountdownTimer = null;
    var successRedirectSeconds = 20;
    var submitProgressPercent = 0;
    var indexedDbAvailable = 'indexedDB' in window;
    var debugEnabled = isSubmissionDebugEnabled();

    if (!form || !countInput || !articlesContainer || !articleTemplate || !submitButton || !errorNode || !successNode) {
      return;
    }

    function setError(message) {
      errorNode.hidden = !message;
      errorNode.textContent = message || '';
    }

    function setSuccess(message) {
      successNode.hidden = !message;
      successNode.textContent = message || '';
    }

    function setSubmitStatus(message) {
      if (!submitStatusNode) {
        return;
      }

      submitStatusNode.hidden = !message;
      submitStatusNode.textContent = message || '';
    }

    function setSubmitting(isSubmitting) {
      submitButton.disabled = isSubmitting || hasAnyImageProcessing() || !areConfirmationsAccepted();
      submitButton.textContent = isSubmitting ? 'Skickar förfrågan…' : submitLabel;

      if (isSubmitting) {
        setSubmitStatus('Vi laddar upp bilder och skapar ditt ärende. Det kan ta en liten stund.');
      } else {
        setSubmitStatus('');
      }
    }

    function setSubmitComplete() {
      submitButton.disabled = true;
      submitButton.textContent = 'Förfrågan skickad';
      setSubmitStatus('');
    }

    function startSlowSubmitTimer() {
      window.clearTimeout(slowSubmitTimer);
      slowSubmitTimer = window.setTimeout(function () {
        setSubmitStatus('Bilder laddas fortfarande upp. Stäng inte sidan.');
      }, 5000);
    }

    function stopSlowSubmitTimer() {
      window.clearTimeout(slowSubmitTimer);
      slowSubmitTimer = null;
    }

    function getSubmitWorkloadEstimate() {
      var articleNodes = getArticleNodes();
      var articleCount = articleNodes.length || 1;
      var imageCount = 0;

      articleNodes.forEach(function (articleNode) {
        var index = Number(articleNode.getAttribute('data-index'));

        ['front', 'label', 'back', 'care_label'].forEach(function (imageType) {
          if (getDraftArticleImage(index, imageType)) {
            imageCount += 1;
          }
        });
      });

      if (articleCount <= 3) {
        return {
          article_count: articleCount,
          image_count: imageCount,
          text: 'Beräknad tid: cirka 15–30 sekunder.'
        };
      }

      if (articleCount <= 10) {
        return {
          article_count: articleCount,
          image_count: imageCount,
          text: 'Beräknad tid: cirka 30–90 sekunder.'
        };
      }

      return {
        article_count: articleCount,
        image_count: imageCount,
        text: 'Beräknad tid: upp till 2 minuter.'
      };
    }

    function getSubmitProgressLabel(percent) {
      if (percent >= 100) {
        return 'Klart';
      }

      if (percent >= 72) {
        return 'Sparar artiklar…';
      }

      if (percent >= 48) {
        return 'Skapar ärende…';
      }

      if (percent >= 18) {
        return 'Laddar upp bilder…';
      }

      return 'Förbereder bilder…';
    }

    function setSubmitProgress(percent, label) {
      var safePercent = Math.max(0, Math.min(100, Math.round(percent || 0)));

      submitProgressPercent = safePercent;

      if (modalProgressBarNode) {
        modalProgressBarNode.style.width = safePercent + '%';
      }

      if (modalProgressPercentNode) {
        modalProgressPercentNode.textContent = safePercent + '%';
      }

      if (modalProgressLabelNode) {
        modalProgressLabelNode.textContent = label || getSubmitProgressLabel(safePercent);
      }
    }

    function startSubmitProgress() {
      window.clearInterval(submitProgressTimer);
      setSubmitProgress(8, 'Förbereder bilder…');

      submitProgressTimer = window.setInterval(function () {
        var nextPercent;

        if (submitProgressPercent >= 90) {
          return;
        }

        nextPercent = submitProgressPercent + (submitProgressPercent < 35 ? 4 : (submitProgressPercent < 70 ? 3 : 1));
        setSubmitProgress(Math.min(nextPercent, 90));
      }, 950);
    }

    function completeSubmitProgress() {
      window.clearInterval(submitProgressTimer);
      submitProgressTimer = null;
      setSubmitProgress(100, 'Klart');
    }

    function stopSubmitProgress() {
      window.clearInterval(submitProgressTimer);
      submitProgressTimer = null;
    }

    function stopSuccessRedirect() {
      window.clearTimeout(successRedirectTimer);
      window.clearInterval(successCountdownTimer);
      successRedirectTimer = null;
      successCountdownTimer = null;
    }

    function goToHomePage() {
      stopSuccessRedirect();
      window.location.href = '/';
    }

    function reloadCleanRegistrationPage() {
      stopSuccessRedirect();
      clearDraft().finally(function () {
        window.location.href = window.location.pathname;
      });
    }

    function startSuccessRedirectCountdown() {
      var remaining = successRedirectSeconds;

      stopSuccessRedirect();

      function updateCountdownText() {
        if (modalNextNode) {
          modalNextNode.hidden = false;
          modalNextNode.textContent = 'Du skickas vidare till startsidan om ' + remaining + ' sekunder.';
        }
      }

      updateCountdownText();

      successCountdownTimer = window.setInterval(function () {
        remaining -= 1;
        if (remaining <= 0) {
          goToHomePage();
          return;
        }
        updateCountdownText();
      }, 1000);

      successRedirectTimer = window.setTimeout(goToHomePage, successRedirectSeconds * 1000);
    }

    function showSubmissionModal(type, settings) {
      var data = settings || {};

      if (!modalNode) {
        return;
      }

      modalNode.classList.toggle('ns-submission__modal--success', type === 'success');
      modalNode.classList.toggle('ns-submission__modal--error', type === 'error');
      modalNode.classList.toggle('ns-submission__modal--loading', type === 'loading');
      modalNode.classList.toggle('ns-submission__modal--actionable', Boolean(data.actions));
      modalNode.hidden = false;

      if (modalTitleNode) {
        modalTitleNode.textContent = data.title || '';
      }

      if (modalCopyNode) {
        modalCopyNode.textContent = data.copy || '';
      }

      if (modalMetaNode) {
        modalMetaNode.hidden = !data.meta;
        modalMetaNode.textContent = data.meta || '';
      }

      if (modalNextNode) {
        modalNextNode.hidden = !data.next;
        modalNextNode.textContent = data.next || '';
      }

      if (modalProgressNode) {
        modalProgressNode.hidden = type !== 'loading';
      }

      if (modalActionsNode) {
        modalActionsNode.hidden = !data.actions;
      }

      window.setTimeout(function () {
        if (modalDialog) {
          modalDialog.focus();
        }
      }, 0);
    }

    function closeSubmissionModal() {
      if (isSubmitting && !hasSubmittedSuccessfully) {
        return;
      }

      if (hasSubmittedSuccessfully) {
        return;
      }

      if (modalNode) {
        modalNode.hidden = true;
      }
    }

    function setDraftStatus(message) {
      if (!draftStatusNode) {
        return;
      }

      draftStatusNode.textContent = message || '';
    }

    function showDraftImageWarning() {
      if (draftWarningNode) {
        draftWarningNode.hidden = false;
      }
    }

    function logDebug(label, data) {
      if (!debugEnabled || !window.console || typeof window.console.log !== 'function') {
        return;
      }

      window.console.log('[NSI submission] ' + label, data);
    }

    function warnDebug(label, data) {
      if (!debugEnabled || !window.console || typeof window.console.warn !== 'function') {
        return;
      }

      window.console.warn('[NSI submission] ' + label, data);
    }

    function buildPayloadDebugSummary(payload) {
      var data = payload || {};
      var articles = Array.isArray(data.articles) ? data.articles : [];
      var totalImagePayloadBytes = getPayloadImageBytes(data);

      return {
        endpoint_url: endpoint || DEFAULT_ENDPOINT,
        payload_type: data.type || '',
        article_count: data.article_count || 0,
        total_image_payload_size: formatBytes(totalImagePayloadBytes),
        total_image_payload_bytes: totalImagePayloadBytes,
        article_images: articles.map(function (article) {
          return {
            index: article.index,
            has_front: Boolean(article.image_front),
            has_label: Boolean(article.image_label),
            has_back: Boolean(article.image_back),
            has_care_label: Boolean(article.image_care_label)
          };
        })
      };
    }

    function getPayloadImageBytes(payload) {
      var data = payload || {};
      var total = 0;

      function addImage(image) {
        if (image && image.size) {
          total += Number(image.size) || 0;
        }
      }

      (Array.isArray(data.articles) ? data.articles : []).forEach(function (article) {
        addImage(article && article.image_front);
        addImage(article && article.image_label);
        addImage(article && article.image_back);
        addImage(article && article.image_care_label);
      });

      return total;
    }

    function getEndpointWarning(result, responseText) {
      var message = result && result.message ? result.message : '';
      var reason = result && (result.reason || result.access_reason) ? safeText(result.reason || result.access_reason) : '';
      var body = safeText(responseText).toLowerCase();

      if (isLegacyNsPaseAccessMessage(message) || reason === 'missing_access' || reason === 'invalid_access') {
        return 'Endpoint verkar köra gammal Apps Script-version.';
      }

      if (body.indexOf('<!doctype html') !== -1 || body.indexOf('<html') !== -1 || body.indexOf('sidan hittades inte') !== -1 || body.indexOf('det går inte att öppna filen') !== -1) {
        return 'Endpoint svarar inte som Apps Script JSON-webapp. Kontrollera endpoint_url/deployment.';
      }

      return '';
    }

    function openDraftDb() {
      return new Promise(function (resolve, reject) {
        var request;

        if (!indexedDbAvailable) {
          reject(new Error('IndexedDB saknas.'));
          return;
        }

        request = window.indexedDB.open(DRAFT_DB_NAME, DRAFT_DB_VERSION);

        request.onupgradeneeded = function () {
          var db = request.result;

          if (!db.objectStoreNames.contains(DRAFT_IMAGE_STORE)) {
            db.createObjectStore(DRAFT_IMAGE_STORE, { keyPath: 'key' });
          }
        };

        request.onsuccess = function () {
          resolve(request.result);
        };

        request.onerror = function () {
          reject(request.error || new Error('IndexedDB kunde inte öppnas.'));
        };
      });
    }

    function withDraftImageStore(mode, callback) {
      return openDraftDb().then(function (db) {
        return new Promise(function (resolve, reject) {
          var transaction = db.transaction(DRAFT_IMAGE_STORE, mode);
          var store = transaction.objectStore(DRAFT_IMAGE_STORE);
          var callbackResult;

          transaction.oncomplete = function () {
            db.close();
            resolve(callbackResult);
          };

          transaction.onerror = function () {
            db.close();
            reject(transaction.error || new Error('IndexedDB-transaktion misslyckades.'));
          };

          callbackResult = callback(store);
        });
      });
    }

    function saveDraftImageRecord(key, images) {
      if (!indexedDbAvailable) {
        showDraftImageWarning();
        return Promise.resolve(false);
      }

      return withDraftImageStore('readwrite', function (store) {
        store.put({
          key: key,
          draft_id: draftId,
          images: images || [],
          updated_at: new Date().toISOString()
        });
      }).then(function () {
        return true;
      }).catch(function () {
        showDraftImageWarning();
        return false;
      });
    }

    function loadDraftImageRecord(key) {
      if (!indexedDbAvailable) {
        showDraftImageWarning();
        return Promise.resolve([]);
      }

      return openDraftDb().then(function (db) {
        return new Promise(function (resolve, reject) {
          var transaction = db.transaction(DRAFT_IMAGE_STORE, 'readonly');
          var store = transaction.objectStore(DRAFT_IMAGE_STORE);
          var request = store.get(key);

          request.onsuccess = function () {
            resolve(request.result && Array.isArray(request.result.images) ? request.result.images : []);
          };

          request.onerror = function () {
            reject(request.error || new Error('Kunde inte läsa bildutkast.'));
          };

          transaction.oncomplete = function () {
            db.close();
          };

          transaction.onerror = function () {
            db.close();
          };
        });
      }).catch(function () {
        showDraftImageWarning();
        return [];
      });
    }

    function clearDraftImages() {
      if (!indexedDbAvailable) {
        return Promise.resolve();
      }

      return withDraftImageStore('readwrite', function (store) {
        store.clear();
      }).catch(function () {
        showDraftImageWarning();
      });
    }

    function buildDraftImageKey(articleIndex, imageType) {
      return [draftId, articleIndex, imageType].join('|');
    }

    function imageToPreviewFile(image, fallbackName) {
      return {
        name: image && image.filename ? image.filename : fallbackName,
        size: image && image.size ? image.size : 0,
        dataUrl: image && image.data ? 'data:' + (image.mime_type || 'image/jpeg') + ';base64,' + image.data : ''
      };
    }

    function getImageTileFromPreview(previewNode) {
      return previewNode && previewNode.closest ? previewNode.closest('.ns-submission__image-tile') : null;
    }

    function getImageTileFromNote(noteNode) {
      return noteNode && noteNode.closest ? noteNode.closest('.ns-submission__image-tile') : null;
    }

    function setImageTileAction(tile, hasImage) {
      var action = tile ? tile.querySelector('.ns-submission__image-action') : null;

      if (action) {
        action.textContent = hasImage ? 'Byt bild' : 'Välj bild';
      }
    }

    function setImageTileHasImage(previewNode, hasImage) {
      var tile = getImageTileFromPreview(previewNode);

      if (previewNode) {
        previewNode.classList.toggle('has-image', Boolean(hasImage));
      }

      if (tile) {
        tile.classList.toggle('has-image', Boolean(hasImage));
        setImageTileAction(tile, Boolean(hasImage));
      }
    }

    function setImageTileProcessing(noteNode, isProcessing) {
      var tile = getImageTileFromNote(noteNode);

      if (tile) {
        tile.classList.toggle('is-processing', Boolean(isProcessing));
      }

      if (!noteNode || !isProcessing) {
        return;
      }

      noteNode.classList.remove('ns-submission__file-note--error');
      noteNode.textContent = 'Bearbetar bild…';
      setImageTileAction(tile, true);
    }

    function setImageTileError(noteNode, message) {
      var tile = getImageTileFromNote(noteNode);

      if (tile) {
        tile.classList.remove('is-processing');
        setImageTileAction(tile, true);
      }

      if (noteNode) {
        noteNode.classList.add('ns-submission__file-note--error');
        noteNode.textContent = message || 'Bilden kunde inte användas.';
      }
    }

    function setImageTileNote(noteNode, images, emptyText) {
      var list = Array.isArray(images) ? images : [];
      var firstImage = list[0];
      var tile = getImageTileFromNote(noteNode);

      if (!noteNode || !tile) {
        return false;
      }

      noteNode.classList.remove('ns-submission__file-note--error');
      tile.classList.remove('is-processing');
      noteNode.textContent = firstImage ? 'Bild klar · ' + formatBytes(firstImage.size || 0) : emptyText;
      setImageTileAction(tile, Boolean(firstImage));
      return true;
    }

    function renderCompressedImagePreview(images, previewNode) {
      var previewFiles = (Array.isArray(images) ? images : []).map(function (image, index) {
        return imageToPreviewFile(image, 'Sparad bild ' + (index + 1));
      });
      var isTilePreview = Boolean(getImageTileFromPreview(previewNode));
      var tileFile = previewFiles[0];
      var tileImage;

      if (!previewNode) {
        return;
      }

      previewNode.innerHTML = '';

      if (isTilePreview) {
        if (tileFile && tileFile.dataUrl) {
          tileImage = document.createElement('img');
          tileImage.alt = tileFile.name || 'Vald bild';
          tileImage.src = tileFile.dataUrl;
          previewNode.appendChild(tileImage);
        }

        setImageTileHasImage(previewNode, Boolean(tileFile && tileFile.dataUrl));
        return;
      }

      previewFiles.forEach(function (file) {
        var item = document.createElement('div');
        var image = document.createElement('img');
        var caption = document.createElement('span');

        item.className = 'ns-submission__preview';
        image.alt = file.name || 'Sparad bild';
        image.src = file.dataUrl;
        caption.textContent = (file.name || 'Sparad bild') + ' · ' + formatBytes(file.size);

        item.appendChild(image);
        item.appendChild(caption);
        previewNode.appendChild(item);
      });
    }

    function getNormalizedPhone() {
      return normalizePhoneNumber(phoneCountryInput ? phoneCountryInput.value : '', phoneInput ? phoneInput.value : '');
    }

    function updatePhonePreview() {
      var normalized = getNormalizedPhone();
      var hasInput = phoneInput && phoneInput.value.trim();
      var isValid = isValidNormalizedPhone(normalized);

      if (!phonePreview) {
        return;
      }

      phonePreview.classList.toggle('ns-submission__field-note--error', Boolean(hasInput && !isValid));

      if (!hasInput) {
        phonePreview.textContent = 'Vi sparar ditt nummer i internationellt format.';
      } else if (isValid) {
        phonePreview.textContent = 'Vi sparar ditt nummer som +' + normalized;
      } else {
        phonePreview.textContent = 'Telefonnumret ser inte giltigt ut. Kontrollera land och nummer.';
      }

      updateStepAccordions();
    }

    function getCurrentStepLabel(target) {
      var section = target && target.closest ? target.closest('[data-step-label]') : null;
      return section ? section.getAttribute('data-step-label') : activeStep;
    }

    function getCurrentStepKey(target) {
      var section = target && target.closest ? target.closest('[data-ns-submission-step]') : null;
      return section ? section.getAttribute('data-ns-submission-step') : '';
    }

    function ensureArticleImageState(articleIndex) {
      if (!imageProcessing.articles[articleIndex]) {
        imageProcessing.articles[articleIndex] = {};
      }

      if (!imageErrors.articles[articleIndex]) {
        imageErrors.articles[articleIndex] = {};
      }

      if (!imageProcessingRuns.articles[articleIndex]) {
        imageProcessingRuns.articles[articleIndex] = {};
      }
    }

    function setImageProcessingState(articleIndex, imageType, isProcessing) {
      if (articleIndex) {
        ensureArticleImageState(articleIndex);
        imageProcessing.articles[articleIndex][imageType] = Boolean(isProcessing);
      }
    }

    function setImageErrorState(articleIndex, imageType, message) {
      if (articleIndex) {
        ensureArticleImageState(articleIndex);
        imageErrors.articles[articleIndex][imageType] = message || '';
      }
    }

    function nextImageProcessingRun(articleIndex, imageType) {
      if (articleIndex) {
        ensureArticleImageState(articleIndex);
        imageProcessingRuns.articles[articleIndex][imageType] = (imageProcessingRuns.articles[articleIndex][imageType] || 0) + 1;
        return imageProcessingRuns.articles[articleIndex][imageType];
      }

      return 0;
    }

    function getImageProcessingRun(articleIndex, imageType) {
      if (articleIndex) {
        ensureArticleImageState(articleIndex);
        return imageProcessingRuns.articles[articleIndex][imageType] || 0;
      }

      return 0;
    }

    function isImageProcessing(articleIndex, imageType) {
      if (articleIndex) {
        ensureArticleImageState(articleIndex);
        return Boolean(imageProcessing.articles[articleIndex][imageType]);
      }

      return false;
    }

    function getImageError(articleIndex, imageType) {
      if (articleIndex) {
        ensureArticleImageState(articleIndex);
        return imageErrors.articles[articleIndex][imageType] || '';
      }

      return '';
    }

    function hasAnyImageProcessing() {
      return Object.keys(imageProcessing.articles).some(function (articleIndex) {
        return Object.keys(imageProcessing.articles[articleIndex] || {}).some(function (imageType) {
          return Boolean(imageProcessing.articles[articleIndex][imageType]);
        });
      });
    }

    function getFirstImageError() {
      var articleIndexes;

      articleIndexes = Object.keys(imageErrors.articles);

      for (var i = 0; i < articleIndexes.length; i += 1) {
        var articleIndex = articleIndexes[i];
        var imageTypes = Object.keys(imageErrors.articles[articleIndex] || {});

        for (var j = 0; j < imageTypes.length; j += 1) {
          var errorMessage = imageErrors.articles[articleIndex][imageTypes[j]];

          if (errorMessage) {
            return errorMessage;
          }
        }
      }

      return '';
    }

    function getStepNode(stepKey) {
      return stepNodes.filter(function (step) {
        return step.getAttribute('data-ns-submission-step') === stepKey;
      })[0] || null;
    }

    function setStepSummary(stepKey, text) {
      var node = root.querySelector('[data-ns-submission-step-summary="' + stepKey + '"]');

      if (node) {
        node.textContent = text;
      }
    }

    function setStepOpen(stepKey, isOpen) {
      var node = getStepNode(stepKey);

      if (node) {
        node.open = Boolean(isOpen);
      }
    }

    function getNextStepKey(stepKey) {
      var index = STEP_ORDER.indexOf(stepKey);

      return index !== -1 ? STEP_ORDER[index + 1] || '' : '';
    }

    function setInlineError(node, message) {
      if (!node) {
        return;
      }

      node.hidden = !message;
      node.textContent = message || '';
    }

    function setStepError(stepKey, message) {
      setInlineError(root.querySelector('[data-ns-submission-step-error="' + stepKey + '"]'), message);
    }

    function setArticleError(articleNode, message) {
      setInlineError(articleNode ? articleNode.querySelector('[data-ns-submission-article-error]') : null, message);
    }

    function focusWithoutScroll(element) {
      var scrollX;
      var scrollY;

      if (!element || typeof element.focus !== 'function') {
        return;
      }

      try {
        element.focus({ preventScroll: true });
      } catch (error) {
        scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
        scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        element.focus();
        window.scrollTo(scrollX, scrollY);
      }
    }

    function scrollToElement(element, block) {
      if (!element || !element.scrollIntoView) {
        return;
      }

      window.requestAnimationFrame(function () {
        element.scrollIntoView({
          behavior: 'smooth',
          block: block || 'start'
        });
      });
    }

    function getDetailsSummary(detailsNode) {
      return detailsNode && detailsNode.querySelector ? detailsNode.querySelector('summary') : null;
    }

    function scrollToDetailsSummary(detailsNode) {
      var summary = getDetailsSummary(detailsNode) || detailsNode;

      focusWithoutScroll(summary);
      scrollToElement(summary, 'start');
    }

    function keepElementPositionAfterCollapse(element, beforeTop) {
      window.requestAnimationFrame(function () {
        var afterTop;

        if (!element || !element.getBoundingClientRect) {
          return;
        }

        afterTop = element.getBoundingClientRect().top;
        window.scrollBy({
          top: afterTop - beforeTop,
          left: 0,
          behavior: 'auto'
        });
      });
    }

    function scrollToArticleCard(articleNode) {
      scrollToDetailsSummary(articleNode);
    }

    function getArticleNodes() {
      return Array.prototype.slice.call(articlesContainer.querySelectorAll('[data-ns-submission-article]'));
    }

    function areConfirmationsAccepted() {
      return Boolean(
        form.elements.accepted_item_confirmation &&
        form.elements.accepted_item_confirmation.checked &&
        form.elements.accepted_terms &&
        form.elements.accepted_terms.checked
      );
    }

    function getArticleCount() {
      return getArticleNodes().length;
    }

    function syncArticleCountInput() {
      if (countInput) {
        countInput.value = String(getArticleCount());
      }
    }

    function hasArticleImage(articleNode, articleIndex, imageType, selector) {
      var draftImage = getDraftArticleImage(articleIndex, imageType);

      return Boolean(articleNode.querySelector(selector)) && Boolean(draftImage);
    }

    function getArticleCompletionState(articleNode) {
      var index = Number(articleNode.getAttribute('data-index'));
      var brandInput = articleNode.querySelector('[data-ns-submission-brand]');
      var typeInput = articleNode.querySelector('[data-ns-submission-type]');
      var colorInput = articleNode.querySelector('[data-ns-submission-color]');
      var sizeInput = articleNode.querySelector('[data-ns-submission-size]');
      var brand = brandInput ? brandInput.value.trim() : '';
      var brandStatus = getBrandStatus(brand);
      var matchedType = getMatchedItemType(typeInput ? typeInput.value : '');
      var hasFront = hasArticleImage(articleNode, index, 'front', '[data-ns-submission-image-front]');
      var hasLabel = hasArticleImage(articleNode, index, 'label', '[data-ns-submission-image-label]');
      var hasImageProcessingState = isImageProcessing(index, 'front') ||
        isImageProcessing(index, 'label') ||
        isImageProcessing(index, 'back') ||
        isImageProcessing(index, 'care_label');
      var imageError = getImageError(index, 'front') ||
        getImageError(index, 'label') ||
        getImageError(index, 'back') ||
        getImageError(index, 'care_label');
      var hasRequiredFields = Boolean(
        brand &&
        !isBlockedBrandStatus(brandStatus) &&
        matchedType &&
        colorInput && colorInput.value.trim() &&
        sizeInput && sizeInput.value
      );
      var hasRequiredImages = hasFront && hasLabel;
      var ready = hasRequiredFields && hasRequiredImages && !hasImageProcessingState && !imageError;
      var saved = articleNode.getAttribute('data-saved') === 'true';

      return {
        index: index,
        brand: brand,
        type: matchedType ? matchedType.name : safeText(typeInput && typeInput.value).trim(),
        fieldsComplete: hasRequiredFields,
        imagesComplete: hasRequiredImages,
        ready: ready,
        saved: saved,
        complete: ready && saved,
        statusText: !hasRequiredFields ? 'Saknar uppgifter' : (hasImageProcessingState ? 'Bearbetar bilder' : (imageError ? 'Bildfel' : (!hasRequiredImages ? 'Saknar bilder' : (saved ? 'Klar' : 'Redo att spara'))))
      };
    }

    function updateArticleCardState(articleNode) {
      var state = getArticleCompletionState(articleNode);
      var titleNode = articleNode.querySelector('[data-ns-submission-article-title]');
      var metaNode = articleNode.querySelector('[data-ns-submission-article-meta]');
      var titleParts = [];

      if (state.brand) {
        titleParts.push(state.brand);
      }

      if (state.type) {
        titleParts.push(state.type);
      }

      if (titleNode) {
        titleNode.textContent = titleParts.length
          ? 'Artikel ' + state.index + ' – ' + titleParts.join(', ')
          : 'Artikel ' + state.index + ' – Ej klar';
      }

      if (metaNode) {
        metaNode.textContent = state.statusText;
      }

      articleNode.classList.toggle('is-complete', state.complete);
      articleNode.classList.toggle('is-ready', state.ready && !state.saved);
      articleNode.classList.toggle('is-saved', state.saved);
      articleNode.classList.toggle('has-error', !state.complete && (state.brand || state.type || state.fieldsComplete || state.imagesComplete));

      return state;
    }

    function markArticleUnsaved(articleNode) {
      if (!articleNode || articleNode.getAttribute('data-saved') !== 'true') {
        return;
      }

      articleNode.removeAttribute('data-saved');
      articleNode.classList.remove('is-saved');
      updateArticleCardState(articleNode);
      setAddArticleAvailability();
    }

    function areAllArticlesSavedAndComplete() {
      var articleNodes = getArticleNodes();

      return Boolean(articleNodes.length) && articleNodes.every(function (articleNode) {
        return updateArticleCardState(articleNode).complete;
      });
    }

    function getArticleCompletionSummary() {
      var articleNodes = getArticleNodes();
      var completeCount = 0;

      articleNodes.forEach(function (articleNode) {
        if (updateArticleCardState(articleNode).complete) {
          completeCount += 1;
        }
      });

      return {
        total: articleNodes.length,
        complete: completeCount
      };
    }

    function getFormCompletionState() {
      var name = form.elements.name ? form.elements.name.value.trim() : '';
      var email = form.elements.email ? form.elements.email.value.trim() : '';
      var phone = getNormalizedPhone();
      var articleSummary = getArticleCompletionSummary(false);
      var articleCount = articleSummary.total;
      var confirmComplete = areConfirmationsAccepted();

      return {
        contact: {
          complete: Boolean(name && email && isValidNormalizedPhone(phone)),
          summary: name && email && phone ? name + ' · ' + email + ' · +' + phone : 'Inte ifyllt'
        },
        articles: {
          complete: Boolean(articleCount && articleCount <= MAX_ARTICLES && articleSummary.total === articleCount && articleSummary.complete === articleCount),
          summary: articleCount ? articleCount + ' artiklar · ' + articleSummary.complete + ' av ' + articleCount + ' sparade' : '1 artikel'
        },
        confirm: {
          complete: confirmComplete,
          summary: confirmComplete ? 'Bekräftelser klara' : 'Bekräftelser saknas'
        }
      };
    }

    function updateStepAccordions() {
      var states = getFormCompletionState();

      setStepSummary('contact', states.contact.summary);
      setStepSummary('articles', states.articles.summary);
      setStepSummary('confirm', states.confirm.summary);

      Object.keys(states).forEach(function (stepKey) {
        var node = getStepNode(stepKey);

        if (!node) {
          return;
        }

        node.classList.toggle('is-complete', states[stepKey].complete);
        node.classList.toggle('has-error', false);
      });

      if (!isSubmitting && !hasSubmittedSuccessfully) {
        submitButton.disabled = hasAnyImageProcessing() || !areConfirmationsAccepted();
      }

      syncArticleCountInput();
      setAddArticleAvailability();
    }

    function validateArticleForSave(articleNode) {
      var index = Number(articleNode.getAttribute('data-index'));
      var brandInput = articleNode.querySelector('[data-ns-submission-brand]');
      var typeInput = articleNode.querySelector('[data-ns-submission-type]');
      var colorInput = articleNode.querySelector('[data-ns-submission-color]');
      var sizeInput = articleNode.querySelector('[data-ns-submission-size]');
      var brand = brandInput ? brandInput.value.trim() : '';
      var brandStatus = getBrandStatus(brand);
      var matchedType = getMatchedItemType(typeInput ? typeInput.value : '');
      var imageError = getImageError(index, 'front') ||
        getImageError(index, 'label') ||
        getImageError(index, 'back') ||
        getImageError(index, 'care_label');

      if (!brand) {
        return 'Fyll i varumärke för artikeln.';
      }

      if (isBlockedBrandStatus(brandStatus)) {
        return 'Det här varumärket tar vi inte emot via förhandsregistreringen.';
      }

      if (!matchedType) {
        return 'Välj typ av vara från listan.';
      }

      if (!colorInput || !colorInput.value.trim()) {
        return 'Fyll i färg för artikeln.';
      }

      if (!sizeInput || !sizeInput.value) {
        return 'Välj storlek för artikeln.';
      }

      if (isImageProcessing(index, 'front') || isImageProcessing(index, 'label') || isImageProcessing(index, 'back') || isImageProcessing(index, 'care_label')) {
        return 'Vänta tills bilderna är klara.';
      }

      if (imageError) {
        return imageError;
      }

      if (!getDraftArticleImage(index, 'front')) {
        return 'Ladda upp framsida för artikeln.';
      }

      if (!getDraftArticleImage(index, 'label')) {
        return 'Ladda upp märkeslapp för artikeln.';
      }

      return '';
    }

    function scrollToArticleValidationTarget(articleNode, error) {
      var text = normalizeText(error);
      var target = null;

      if (!articleNode) {
        return;
      }

      if (/varumärke/.test(text)) {
        target = articleNode.querySelector('[data-ns-submission-brand]');
      } else if (/typ/.test(text)) {
        target = articleNode.querySelector('[data-ns-submission-type]');
      } else if (/färg/.test(text)) {
        target = articleNode.querySelector('[data-ns-submission-color]');
      } else if (/storlek/.test(text)) {
        target = articleNode.querySelector('[data-ns-submission-size]');
      } else if (/framsida/.test(text)) {
        target = articleNode.querySelector('[data-ns-submission-image-dropzone="front"]');
      } else if (/märkeslapp/.test(text)) {
        target = articleNode.querySelector('[data-ns-submission-image-dropzone="label"]');
      } else if (/baksida/.test(text)) {
        target = articleNode.querySelector('[data-ns-submission-image-dropzone="back"]');
      } else if (/tvättråd|materialetikett/.test(text)) {
        target = articleNode.querySelector('[data-ns-submission-image-dropzone="care_label"]');
      }

      articleNode.open = true;
      focusWithoutScroll(target || getDetailsSummary(articleNode));
      scrollToElement(target || getDetailsSummary(articleNode) || articleNode, 'center');
    }

    function scrollToStepValidationTarget(stepKey, error) {
      var stepNode = getStepNode(stepKey);
      var text = normalizeText(error);
      var target = null;
      var articleNodes;
      var firstProblemArticle;

      if (!stepNode) {
        return;
      }

      if (stepKey === 'contact') {
        if (/namn/.test(text) && form.elements.name && !form.elements.name.value.trim()) {
          target = form.elements.name;
        } else if (/e-post/.test(text) && form.elements.email && !form.elements.email.value.trim()) {
          target = form.elements.email;
        } else if (/telefon/.test(text)) {
          target = form.elements.phone;
        } else {
          target = form.elements.name || getDetailsSummary(stepNode);
        }
      } else if (stepKey === 'articles') {
        articleNodes = getArticleNodes();
        firstProblemArticle = articleNodes.filter(function (articleNode) {
          return articleNode.open ||
            articleNode.getAttribute('data-saved') !== 'true' ||
            Boolean(validateArticleForSave(articleNode));
        })[0] || articleNodes[0];

        if (firstProblemArticle) {
          scrollToArticleValidationTarget(firstProblemArticle, validateArticleForSave(firstProblemArticle) || error);
          return;
        }
      } else if (stepKey === 'confirm') {
        if (form.elements.accepted_item_confirmation && !form.elements.accepted_item_confirmation.checked) {
          target = form.elements.accepted_item_confirmation;
        } else if (form.elements.accepted_terms && !form.elements.accepted_terms.checked) {
          target = form.elements.accepted_terms;
        }
      }

      setStepOpen(stepKey, true);
      focusWithoutScroll(target || getDetailsSummary(stepNode));
      scrollToElement(target || getDetailsSummary(stepNode) || stepNode, 'center');
    }

    function validateStepForSave(stepKey) {
      var articleNodes = getArticleNodes();
      var articleCount = articleNodes.length;
      var firstArticleError = '';

      if (stepKey === 'contact') {
        if (!form.elements.name.value.trim() || !form.elements.email.value.trim() || !form.elements.phone.value.trim()) {
          return 'Fyll i namn, e-post och telefonnummer.';
        }

        if (!isValidNormalizedPhone(getNormalizedPhone())) {
          return 'Telefonnumret ser inte giltigt ut. Kontrollera land och nummer.';
        }

        return '';
      }

      if (stepKey === 'articles') {
        if (!articleCount || articleCount < 1 || articleCount > MAX_ARTICLES) {
          return 'Max 20 artiklar per registrering. Skapa en ny registrering för fler artiklar.';
        }

        articleNodes.forEach(function (articleNode) {
          var error = validateArticleForSave(articleNode);

          setArticleError(articleNode, error);

          if (!firstArticleError && error) {
            firstArticleError = 'Artikel ' + articleNode.getAttribute('data-index') + ' behöver kompletteras.';
            articleNode.open = true;
          } else if (!firstArticleError && articleNode.getAttribute('data-saved') !== 'true') {
            firstArticleError = 'Spara artikel ' + articleNode.getAttribute('data-index') + ' innan du går vidare.';
            articleNode.open = true;
          }
        });

        return firstArticleError;
      }

      if (stepKey === 'confirm') {
        if (!form.elements.accepted_item_confirmation.checked || !form.elements.accepted_terms.checked) {
          return 'Bekräfta varorna och acceptera villkoren.';
        }

        return '';
      }

      return '';
    }

    function saveArticleCard(articleNode) {
      var error = validateArticleForSave(articleNode);
      var beforeTop = articleNode.getBoundingClientRect ? articleNode.getBoundingClientRect().top : 0;
      var summary = getDetailsSummary(articleNode);

      setArticleError(articleNode, error);
      updateArticleCardState(articleNode);

      if (error) {
        articleNode.open = true;
        scrollToArticleValidationTarget(articleNode, error);
        return;
      }

      articleNode.setAttribute('data-saved', 'true');
      articleNode.classList.add('is-saved');
      updateArticleCardState(articleNode);
      focusWithoutScroll(summary);
      articleNode.open = false;
      keepElementPositionAfterCollapse(articleNode, beforeTop);
      scrollToElement(summary || articleNode, 'start');
      updateStepAccordions();
      scheduleDraftSave();
    }

    function saveStep(stepKey) {
      var error = validateStepForSave(stepKey);
      var nextStepKey = getNextStepKey(stepKey);
      var nextStepNode = getStepNode(nextStepKey);
      var nextSummary = getDetailsSummary(nextStepNode);

      setStepError(stepKey, error);
      updateStepAccordions();

      if (error) {
        setStepOpen(stepKey, true);
        scrollToStepValidationTarget(stepKey, error);
        return;
      }

      if (nextStepKey) {
        setStepOpen(nextStepKey, true);
        focusWithoutScroll(nextSummary);
        setStepOpen(stepKey, false);
        scrollToElement(nextSummary || nextStepNode, 'start');
      } else {
        setStepOpen(stepKey, true);
        scrollToDetailsSummary(getStepNode(stepKey));
      }

      scheduleDraftSave();
    }

    function openStepForMessage(message) {
      var text = normalizeText(message);

      if (/telefon|e-post|namn/.test(text)) {
        setStepOpen('contact', true);
      }

      if (/artikel|varumärke|typ|färg|storlek|framsida|märkeslapp|bild/.test(text)) {
        setStepOpen('articles', true);
      }

      if (/bekräfta|villkor/.test(text)) {
        setStepOpen('confirm', true);
      }

      setStepOpen('confirm', true);
    }

    function collectDraftState() {
      var articleNodes = Array.prototype.slice.call(articlesContainer.querySelectorAll('[data-ns-submission-article]'));

      return {
        draft_id: draftId,
        updated_at: new Date().toISOString(),
        active_step: activeStep,
        contact: {
          name: form.elements.name ? form.elements.name.value : '',
          email: form.elements.email ? form.elements.email.value : '',
          phone_country_code: form.elements.phone_country_code ? form.elements.phone_country_code.value : '46',
          phone_raw: form.elements.phone ? form.elements.phone.value : '',
          phone: getNormalizedPhone(),
          customer_id: form.elements.customer_id ? form.elements.customer_id.value : ''
        },
        article_count: articleNodes.length,
        articles: articleNodes.map(function (node) {
          var typeInput = node.querySelector('[data-ns-submission-type]');
          var matchedType = getMatchedItemType(typeInput ? typeInput.value : '');

          return {
            index: Number(node.getAttribute('data-index')),
            saved: node.getAttribute('data-saved') === 'true',
            brand: node.querySelector('[data-ns-submission-brand]') ? node.querySelector('[data-ns-submission-brand]').value : '',
            brand_status: getBrandStatus(node.querySelector('[data-ns-submission-brand]') ? node.querySelector('[data-ns-submission-brand]').value : ''),
            type: typeInput ? typeInput.value : '',
            type_category: matchedType ? matchedType.category || '' : '',
            type_status: matchedType ? 'matched' : '',
            color: node.querySelector('[data-ns-submission-color]') ? node.querySelector('[data-ns-submission-color]').value : '',
            size: node.querySelector('[data-ns-submission-size]') ? node.querySelector('[data-ns-submission-size]').value : '',
            comment: node.querySelector('[data-ns-submission-comment]') ? node.querySelector('[data-ns-submission-comment]').value : ''
          };
        }),
        accepted_item_confirmation: form.elements.accepted_item_confirmation ? form.elements.accepted_item_confirmation.checked : false,
        accepted_terms: form.elements.accepted_terms ? form.elements.accepted_terms.checked : false,
        images_saved_in_indexeddb: true
      };
    }

    function saveDraftNow() {
      if (draftRestoreChoicePending || isRestoringDraft) {
        return;
      }

      try {
        window.localStorage.setItem(draftStorageKey, JSON.stringify(collectDraftState()));
        setDraftStatus('Utkast sparat');
      } catch (error) {
        setDraftStatus('');
      }
    }

    function scheduleDraftSave() {
      if (draftRestoreChoicePending || isRestoringDraft) {
        return;
      }

      window.clearTimeout(draftSaveTimer);
      draftSaveTimer = window.setTimeout(saveDraftNow, 350);
    }

    function getStoredDraft() {
      try {
        return JSON.parse(window.localStorage.getItem(draftStorageKey) || 'null');
      } catch (error) {
        return null;
      }
    }

    function clearDraft() {
      window.clearTimeout(draftSaveTimer);
      try {
        window.localStorage.removeItem(draftStorageKey);
      } catch (error) {}

      draftImages = {
        articles: {}
      };
      imageProcessing = {
        articles: {}
      };
      imageErrors = {
        articles: {}
      };
      imageProcessingRuns = {
        articles: {}
      };
      setDraftStatus('');
      return clearDraftImages();
    }

    function setDraftPromptVisible(isVisible) {
      if (draftPanel) {
        draftPanel.hidden = !isVisible;
      }
    }

    function updateFileStatus(input, noteNode, previewNode, emptyText) {
      var files = Array.prototype.slice.call(input.files || []);
      var imageTile = getImageTileFromNote(noteNode);
      var tooLargeCount = files.filter(function (file) {
        return file.size > 8 * 1024 * 1024;
      }).length;
      var totalOriginalBytes = files.reduce(function (sum, file) {
        return sum + file.size;
      }, 0);

      noteNode.classList.toggle('ns-submission__file-note--error', tooLargeCount > 0);

      if (!files.length) {
        noteNode.textContent = emptyText;
      } else if (tooLargeCount > 0) {
        noteNode.textContent = tooLargeCount + ' bild(er) är mycket stora. Välj mindre bilder om komprimeringen inte går igenom.';
      } else if (imageTile) {
        noteNode.textContent = 'Uppladdad · ' + formatBytes(totalOriginalBytes);
      } else {
        noteNode.textContent = 'Bild uppladdad. ' + files.length + ' bild(er) valda, ursprunglig storlek ' + formatBytes(totalOriginalBytes) + '.';
      }

      if (imageTile) {
        setImageTileAction(imageTile, Boolean(files.length));
      }

      renderFilePreview(files, previewNode);
    }

    async function saveImagesToDraft(input, draftKey, noteNode, previewNode, emptyText, articleIndex, imageType) {
      var files = Array.prototype.slice.call(input && input.files ? input.files : []);
      var images;
      var runId = nextImageProcessingRun(articleIndex, imageType);

      if (!files.length) {
        setImageProcessingState(articleIndex, imageType, false);
        setImageErrorState(articleIndex, imageType, '');
        await saveDraftImageRecord(draftKey, []);

        if (!draftImages.articles[articleIndex]) {
          draftImages.articles[articleIndex] = {};
        }
        draftImages.articles[articleIndex][imageType] = [];

        if (previewNode && getImageTileFromPreview(previewNode)) {
          renderCompressedImagePreview([], previewNode);
        }

        if (noteNode && getImageTileFromNote(noteNode)) {
          setImageTileNote(noteNode, [], emptyText);
        }

        updateStepAccordions();
        scheduleDraftSave();
        return;
      }

      try {
        setImageProcessingState(articleIndex, imageType, true);
        setImageErrorState(articleIndex, imageType, '');
        setImageTileProcessing(noteNode, true);

        if (previewNode) {
          renderFilePreview(files, previewNode);
        }

        updateStepAccordions();
        images = await compressFiles(files);

        if (runId !== getImageProcessingRun(articleIndex, imageType)) {
          return;
        }

        await saveDraftImageRecord(draftKey, images);

        if (!draftImages.articles[articleIndex]) {
          draftImages.articles[articleIndex] = {};
        }
        draftImages.articles[articleIndex][imageType] = images;

        if (noteNode) {
          if (!setImageTileNote(noteNode, images, emptyText)) {
            noteNode.classList.remove('ns-submission__file-note--error');
            noteNode.textContent = images.length
              ? 'Bild uppladdad och sparad som utkast.'
              : emptyText;
          }
        }

        if (previewNode) {
          renderCompressedImagePreview(images, previewNode);
        }

        setImageProcessingState(articleIndex, imageType, false);
        setImageErrorState(articleIndex, imageType, '');
        updateStepAccordions();
        scheduleDraftSave();
      } catch (error) {
        var errorMessage = error && error.message ? error.message : 'Bilden kunde inte användas.';

        if (runId !== getImageProcessingRun(articleIndex, imageType)) {
          return;
        }

        setImageProcessingState(articleIndex, imageType, false);
        setImageErrorState(articleIndex, imageType, errorMessage);

        if (!draftImages.articles[articleIndex]) {
          draftImages.articles[articleIndex] = {};
        }
        draftImages.articles[articleIndex][imageType] = [];

        await saveDraftImageRecord(draftKey, []);

        if (noteNode) {
          setImageTileError(noteNode, errorMessage);
        }

        if (previewNode) {
          renderCompressedImagePreview([], previewNode);
        }

        updateStepAccordions();
        showDraftImageWarning();
      }
    }

    function assignFilesToInput(input, files) {
      var dataTransfer;

      if (!input || !files || !files.length || typeof window.DataTransfer !== 'function') {
        return false;
      }

      dataTransfer = new window.DataTransfer();
      Array.prototype.forEach.call(files, function (file) {
        if (!input.multiple && dataTransfer.items.length >= 1) {
          return;
        }

        if (file && file.type && file.type.indexOf('image/') === 0) {
          dataTransfer.items.add(file);
        }
      });

      if (!dataTransfer.files.length) {
        return false;
      }

      input.files = dataTransfer.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function initDropzone(dropzone, input) {
      if (!dropzone || !input) {
        return;
      }

      ['dragenter', 'dragover'].forEach(function (eventName) {
        dropzone.addEventListener(eventName, function (event) {
          event.preventDefault();
          dropzone.classList.add('is-dragging');
        });
      });

      ['dragleave', 'drop'].forEach(function (eventName) {
        dropzone.addEventListener(eventName, function (event) {
          event.preventDefault();
          dropzone.classList.remove('is-dragging');
        });
      });

      dropzone.addEventListener('drop', function (event) {
        assignFilesToInput(input, event.dataTransfer ? event.dataTransfer.files : null);
      });
    }

    function renderFilePreview(files, previewNode) {
      var tile = getImageTileFromPreview(previewNode);
      var tileFile;
      var tileImage;
      var tileReader;

      if (!previewNode) {
        return;
      }

      previewNode.innerHTML = '';

      if (tile) {
        tileFile = files && files.length ? files[0] : null;

        if (!tileFile) {
          setImageTileHasImage(previewNode, false);
          return;
        }

        tileImage = document.createElement('img');
        tileImage.alt = tileFile.name || 'Vald bild';
        previewNode.appendChild(tileImage);
        setImageTileHasImage(previewNode, true);

        tileReader = new FileReader();
        tileReader.onload = function () {
          tileImage.src = tileReader.result;
        };
        tileReader.readAsDataURL(tileFile);
        return;
      }

      files.slice(0, 8).forEach(function (file) {
        var item = document.createElement('div');
        var image = document.createElement('img');
        var caption = document.createElement('span');
        var reader = new FileReader();

        item.className = 'ns-submission__preview';
        image.alt = file.name || 'Vald bild';
        caption.textContent = (file.name || 'Bild') + ' · ' + formatBytes(file.size);

        item.appendChild(image);
        item.appendChild(caption);
        previewNode.appendChild(item);

        reader.onload = function () {
          image.src = reader.result;
        };

        reader.readAsDataURL(file);
      });
    }

    function getBrandStatus(name) {
      var entry = brandLookup[normalizeText(name)];
      return entry ? entry.status : 'unknown';
    }

    function getBrandStatusLabel(status) {
      if (status === 'approved') {
        return 'Godkänt varumärke';
      }

      if (status === 'restricted' || status === 'rejected') {
        return 'Tas inte emot via förhandsregistrering';
      }

      return 'Manuell bedömning';
    }

    function getBrandMatches(value) {
      var normalizedValue = normalizeText(value);

      if (!normalizedValue) {
        return [];
      }

      return brandEntries
        .filter(function (entry) {
          return entry.normalized.indexOf(normalizedValue) !== -1;
        })
        .slice(0, MAX_SUGGESTIONS)
        .map(function (entry) {
          return {
            value: entry.name,
            label: entry.name,
            meta: getBrandStatusLabel(entry.status),
            status: entry.status
          };
        });
    }

    function isBlockedBrandStatus(status) {
      var normalized = normalizeText(status);
      return normalized === 'restricted' || normalized === 'rejected';
    }

    function updateBrandStatus(input) {
      var article = input.closest('[data-ns-submission-article]');
      var statusNode = article ? article.querySelector('[data-ns-submission-brand-status]') : null;
      var status = getBrandStatus(input.value);

      if (!statusNode || !input.value.trim()) {
        if (statusNode) {
          statusNode.hidden = true;
        }
        return;
      }

      statusNode.className = 'ns-submission__brand-status ns-submission__brand-status--' + status;
      statusNode.hidden = false;

      if (status === 'approved') {
        statusNode.textContent = 'Varumärket finns i vår godkända lista.';
      } else if (status === 'restricted') {
        statusNode.textContent = 'Det här varumärket tar vi inte emot via förhandsregistreringen.';
      } else if (status === 'rejected') {
        statusNode.textContent = 'Det här varumärket tar vi inte emot via förhandsregistreringen.';
      } else {
        statusNode.textContent = 'Varumärket finns inte i listan. Vi gör en manuell bedömning.';
      }
    }

    function buildSuggestionButton(match) {
      var button = document.createElement('button');
      var label = document.createElement('span');
      var meta;

      button.type = 'button';
      button.className = 'ns-submission__suggestion';
      button.setAttribute('role', 'option');
      button.dataset.suggestionValue = match.value || match.label || '';

      if (match.status) {
        button.classList.add('ns-submission__suggestion--' + match.status);
      }

      label.className = 'ns-submission__suggestion-label';
      label.textContent = match.label || match.value || '';
      button.appendChild(label);

      if (match.meta) {
        meta = document.createElement('span');
        meta.className = 'ns-submission__suggestion-meta';
        meta.textContent = match.meta;
        button.appendChild(meta);
      }

      return button;
    }

    function initAutocomplete(config) {
      var input = config.input;
      var list = config.list;
      var getMatches = config.getMatches;
      var onChange = config.onChange || function () {};
      var activeIndex = -1;

      if (!input || !list) {
        return;
      }

      function closeSuggestions() {
        activeIndex = -1;
        list.innerHTML = '';
        list.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }

      function updateActiveSuggestion() {
        var suggestionButtons = list.querySelectorAll('.ns-submission__suggestion');

        Array.prototype.forEach.call(suggestionButtons, function (button, index) {
          button.classList.toggle('is-active', index === activeIndex);
        });
      }

      function applyValue(value) {
        input.value = value;
        onChange(value, input);
        closeSuggestions();
      }

      function showSuggestions(matches) {
        list.innerHTML = '';

        if (!matches.length) {
          closeSuggestions();
          return;
        }

        matches.forEach(function (match) {
          var item = document.createElement('li');
          item.className = 'ns-submission__suggestion-item';
          item.appendChild(buildSuggestionButton(match));
          list.appendChild(item);
        });

        activeIndex = -1;
        list.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      input.addEventListener('input', function () {
        showSuggestions(getMatches(input.value));
        onChange(input.value, input);
      });

      input.addEventListener('focus', function () {
        var matches = getMatches(input.value);

        if (matches.length) {
          showSuggestions(matches);
        }
      });

      input.addEventListener('blur', function () {
        window.setTimeout(function () {
          closeSuggestions();
          onChange(input.value, input);
        }, 120);
      });

      input.addEventListener('keydown', function (event) {
        var suggestionButtons = list.querySelectorAll('.ns-submission__suggestion');

        if (list.hidden || !suggestionButtons.length) {
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          activeIndex = (activeIndex + 1) % suggestionButtons.length;
          updateActiveSuggestion();
          return;
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          activeIndex = activeIndex <= 0 ? suggestionButtons.length - 1 : activeIndex - 1;
          updateActiveSuggestion();
          return;
        }

        if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          applyValue(suggestionButtons[activeIndex].dataset.suggestionValue || suggestionButtons[activeIndex].textContent);
          return;
        }

        if (event.key === 'Escape') {
          closeSuggestions();
        }
      });

      list.addEventListener('mousedown', function (event) {
        var button = event.target.closest('.ns-submission__suggestion');

        if (!button) {
          return;
        }

        event.preventDefault();
        applyValue(button.dataset.suggestionValue || button.textContent);
      });
    }

    function getItemTypeMatches(value) {
      var normalizedValue = normalizeText(value);

      if (!normalizedValue) {
        return [];
      }

      return itemTypeEntries
        .filter(function (entry) {
          return entry.normalized.indexOf(normalizedValue) !== -1;
        })
        .slice(0, MAX_SUGGESTIONS)
        .map(function (entry) {
          return {
            value: entry.name,
            label: entry.name,
            meta: entry.category || ''
          };
        });
    }

    function getMatchedItemType(value) {
      return itemTypeLookup[normalizeText(value)] || null;
    }

    function updateTypeStatus(input) {
      var article = input.closest('[data-ns-submission-article]');
      var statusNode = article ? article.querySelector('[data-ns-submission-type-status]') : null;
      var entry = getMatchedItemType(input.value);

      if (!statusNode) {
        return;
      }

      statusNode.classList.remove('ns-submission__type-status--error');

      if (!input.value.trim()) {
        statusNode.hidden = true;
        statusNode.textContent = '';
        return;
      }

      statusNode.hidden = false;

      if (entry) {
        statusNode.textContent = entry.category ? 'Vald kategori: ' + entry.category + '.' : 'Typen är vald från listan.';
        return;
      }

      statusNode.classList.add('ns-submission__type-status--error');
      statusNode.textContent = 'Välj en typ från listan för bättre datakvalitet.';
    }

    function getArticleFormData(articleNode) {
      var typeInput = articleNode.querySelector('[data-ns-submission-type]');
      var matchedType = getMatchedItemType(typeInput ? typeInput.value : '');

      return {
        brand: articleNode.querySelector('[data-ns-submission-brand]') ? articleNode.querySelector('[data-ns-submission-brand]').value : '',
        brand_status: getBrandStatus(articleNode.querySelector('[data-ns-submission-brand]') ? articleNode.querySelector('[data-ns-submission-brand]').value : ''),
        type: typeInput ? typeInput.value : '',
        type_category: matchedType ? matchedType.category || '' : '',
        type_status: matchedType ? 'matched' : '',
        color: articleNode.querySelector('[data-ns-submission-color]') ? articleNode.querySelector('[data-ns-submission-color]').value : '',
        size: articleNode.querySelector('[data-ns-submission-size]') ? articleNode.querySelector('[data-ns-submission-size]').value : '',
        comment: articleNode.querySelector('[data-ns-submission-comment]') ? articleNode.querySelector('[data-ns-submission-comment]').value : ''
      };
    }

    function getArticleImageSet(articleIndex) {
      return draftImages.articles[articleIndex] || {};
    }

    function articleHasData(articleNode) {
      var index = Number(articleNode.getAttribute('data-index'));
      var data = getArticleFormData(articleNode);
      var images = getArticleImageSet(index);
      var hasSelectedFile = Array.prototype.some.call(articleNode.querySelectorAll('input[type="file"]'), function (input) {
        return Boolean(input.files && input.files.length);
      });

      return Boolean(
        data.brand ||
        data.type ||
        data.color ||
        data.size ||
        data.comment ||
        hasSelectedFile ||
        (images.front && images.front.length) ||
        (images.label && images.label.length) ||
        (images.back && images.back.length) ||
        (images.care_label && images.care_label.length)
      );
    }

    function applyArticleData(articleNode, articleData) {
      var data = articleData || {};
      var brandInput = articleNode.querySelector('[data-ns-submission-brand]');
      var typeInput = articleNode.querySelector('[data-ns-submission-type]');
      var colorInput = articleNode.querySelector('[data-ns-submission-color]');
      var sizeInput = articleNode.querySelector('[data-ns-submission-size]');
      var commentInput = articleNode.querySelector('[data-ns-submission-comment]');

      if (brandInput) {
        brandInput.value = data.brand || '';
        updateBrandStatus(brandInput);
      }

      if (typeInput) {
        typeInput.value = data.type || '';
        updateTypeStatus(typeInput);
      }

      if (colorInput) {
        colorInput.value = data.color || '';
      }

      if (sizeInput) {
        sizeInput.value = data.size || '';
      }

      if (commentInput) {
        commentInput.value = data.comment || '';
      }
    }

    function renderArticleImageSet(articleNode, articleIndex, imageSet) {
      var keys = [
        { payload: 'front', dom: 'front', empty: 'Visa hela artikeln framifrån.' },
        { payload: 'label', dom: 'label', empty: 'Fota nära nacken så hela varumärkeslappen syns tydligt.' },
        { payload: 'back', dom: 'back', empty: 'Valfri bild.' },
        { payload: 'care_label', dom: 'care-label', empty: 'Valfri bild.' }
      ];

      draftImages.articles[articleIndex] = draftImages.articles[articleIndex] || {};

      keys.forEach(function (item) {
        var images = imageSet && imageSet[item.payload] ? imageSet[item.payload] : [];
        var nodes = getArticleImageNodes(articleNode, item.dom);

        draftImages.articles[articleIndex][item.payload] = images;
        renderCompressedImagePreview(images, nodes.preview);
        setDraftImageStatus(nodes.note, images, item.empty);
      });
    }

    function createArticleCard(index, articleData, imageSet, options) {
      var settings = options || {};
      var clone = document.importNode(articleTemplate.content, true);
      var article = clone.querySelector('[data-ns-submission-article]');
      var title = clone.querySelector('[data-ns-submission-article-title]');
      var brandInput = clone.querySelector('[data-ns-submission-brand]');
      var brandSuggestions = clone.querySelector('[data-ns-submission-brand-suggestions]');
      var typeInput = clone.querySelector('[data-ns-submission-type]');
      var typeSuggestions = clone.querySelector('[data-ns-submission-type-suggestions]');

      article.setAttribute('data-index', String(index));
      article.open = settings.open !== false;
      title.textContent = 'Artikel ' + index;

      if (settings.saved) {
        article.setAttribute('data-saved', 'true');
        article.classList.add('is-saved');
      }

      initAutocomplete({
        input: brandInput,
        list: brandSuggestions,
        getMatches: getBrandMatches,
        onChange: function (value, currentInput) {
          var normalizedValue = normalizeText(value);
          var matchedBrand = brandLookup[normalizedValue];

          updateBrandStatus(currentInput);
          if (matchedBrand) {
            currentInput.value = matchedBrand.name;
          }
        }
      });

      initAutocomplete({
        input: typeInput,
        list: typeSuggestions,
        getMatches: getItemTypeMatches,
        onChange: function (value, currentInput) {
          var matchedType = getMatchedItemType(value);
          updateTypeStatus(currentInput);
          if (matchedType) {
            currentInput.value = matchedType.name;
          }
        }
      });

      initArticleImageSlot(clone, index, 'front', 'Visa hela artikeln framifrån.');
      initArticleImageSlot(clone, index, 'label', 'Fota nära nacken så hela varumärkeslappen syns tydligt.');
      initArticleImageSlot(clone, index, 'back', 'Valfri bild.');
      initArticleImageSlot(clone, index, 'care-label', 'Valfri bild.');
      applyArticleData(article, articleData || {});
      renderArticleImageSet(article, index, imageSet || {});
      articlesContainer.appendChild(clone);
      updateArticleCardState(article);
      syncArticleCountInput();

      return article;
    }

    function setAddArticleAvailability() {
      var shouldShow = areAllArticlesSavedAndComplete();

      if (addArticleRow) {
        addArticleRow.hidden = !shouldShow;
      }

      if (addArticleButton) {
        addArticleButton.disabled = false;
        addArticleButton.setAttribute('aria-disabled', getArticleCount() >= MAX_ARTICLES ? 'true' : 'false');
      }
    }

    function addArticleCard(articleData, imageSet, options) {
      var articleCount = getArticleCount();
      var article;

      if (articleCount >= MAX_ARTICLES) {
        setStepError('articles', 'Max 20 artiklar per registrering. Skapa en ny registrering för fler artiklar.');
        return null;
      }

      article = createArticleCard(articleCount + 1, articleData || {}, imageSet || {}, options || { open: true });
      setStepError('articles', '');
      setAddArticleAvailability();
      updateStepAccordions();
      return article;
    }

    function persistArticleImageDrafts() {
      Object.keys(draftImages.articles).forEach(function (articleIndex) {
        ['front', 'label', 'back', 'care_label'].forEach(function (imageType) {
          saveDraftImageRecord(
            buildDraftImageKey(Number(articleIndex), imageType),
            draftImages.articles[articleIndex] && draftImages.articles[articleIndex][imageType]
              ? draftImages.articles[articleIndex][imageType]
              : []
          );
        });
      });
    }

    function rebuildArticlesFromSnapshots(snapshots) {
      articlesContainer.innerHTML = '';
      draftImages.articles = {};
      imageProcessing.articles = {};
      imageErrors.articles = {};
      imageProcessingRuns.articles = {};

      (snapshots.length ? snapshots : [{ data: {}, images: {}, open: true }]).forEach(function (snapshot, index) {
        createArticleCard(index + 1, snapshot.data, snapshot.images, {
          open: Boolean(snapshot.open),
          saved: Boolean(snapshot.saved)
        });
      });

      syncArticleCountInput();
      setAddArticleAvailability();
      persistArticleImageDrafts();
      updateStepAccordions();
      scheduleDraftSave();
    }

    function initArticleImageSlot(articleFragment, articleIndex, key, emptyText) {
      var selectorKey = key.replace(/-([a-z])/g, function (_, letter) {
        return letter.toUpperCase();
      });
      var imageType = key.replace('-', '_');
      var input = articleFragment.querySelector('[data-ns-submission-image-' + key + ']');
      var dropzone = articleFragment.querySelector('[data-ns-submission-image-dropzone="' + imageType + '"]');
      var note = articleFragment.querySelector('[data-ns-submission-image-' + key + '-note]');
      var preview = articleFragment.querySelector('[data-ns-submission-image-' + key + '-preview]');
      var inputId = 'ns-submission-article-' + selectorKey + '-' + root.id + '-' + articleIndex;
      var draftKey = buildDraftImageKey(articleIndex, imageType);

      if (!input || !note) {
        return;
      }

      input.id = inputId;

      if (dropzone) {
        dropzone.htmlFor = inputId;
      }

      input.addEventListener('change', function () {
        markArticleUnsaved(input.closest('[data-ns-submission-article]'));
        saveImagesToDraft(input, draftKey, note, preview, emptyText, articleIndex, imageType);
        updateStepAccordions();
      });

      initDropzone(dropzone, input);
      note.textContent = emptyText;
    }

    async function compressFiles(files) {
      var result = [];
      var list = Array.prototype.slice.call(files || []);
      var index;

      for (index = 0; index < list.length; index += 1) {
        result.push(await compressImage(list[index]));
      }

      return result;
    }

    function getDraftArticleImage(articleIndex, imageType) {
      var images = draftImages.articles[articleIndex] && draftImages.articles[articleIndex][imageType]
        ? draftImages.articles[articleIndex][imageType]
        : [];

      return images[0] || null;
    }

    function setFieldValue(name, value) {
      if (form.elements[name]) {
        form.elements[name].value = value || '';
      }
    }

    function setCheckboxValue(name, value) {
      if (form.elements[name]) {
        form.elements[name].checked = Boolean(value);
      }
    }

    function getArticleImageNodes(articleNode, key) {
      return {
        note: articleNode.querySelector('[data-ns-submission-image-' + key + '-note]'),
        preview: articleNode.querySelector('[data-ns-submission-image-' + key + '-preview]')
      };
    }

    function setDraftImageStatus(noteNode, images, emptyText) {
      if (!noteNode) {
        return;
      }

      if (setImageTileNote(noteNode, images, emptyText)) {
        return;
      }

      noteNode.classList.remove('ns-submission__file-note--error');
      noteNode.textContent = images && images.length ? 'Bild från sparat utkast.' : emptyText;
    }

    async function restoreDraftImagesForArticle(articleNode, articleIndex) {
      var keys = [
        { payload: 'front', dom: 'front', empty: 'Visa hela artikeln framifrån.' },
        { payload: 'label', dom: 'label', empty: 'Fota nära nacken så hela varumärkeslappen syns tydligt.' },
        { payload: 'back', dom: 'back', empty: 'Valfri bild.' },
        { payload: 'care_label', dom: 'care-label', empty: 'Valfri bild.' }
      ];

      draftImages.articles[articleIndex] = draftImages.articles[articleIndex] || {};

      for (var i = 0; i < keys.length; i += 1) {
        var item = keys[i];
        var images = await loadDraftImageRecord(buildDraftImageKey(articleIndex, item.payload));
        var nodes = getArticleImageNodes(articleNode, item.dom);

        draftImages.articles[articleIndex][item.payload] = images;
        renderCompressedImagePreview(images, nodes.preview);
        setDraftImageStatus(nodes.note, images, item.empty);
      }
    }

    async function restoreDraft(draft) {
      var articles = Array.isArray(draft && draft.articles) ? draft.articles : [];
      var articleNodes;

      isRestoringDraft = true;
      setDraftPromptVisible(false);
      draftRestoreChoicePending = false;

      setFieldValue('name', draft && draft.contact && draft.contact.name);
      setFieldValue('email', draft && draft.contact && draft.contact.email);
      setFieldValue('phone_country_code', draft && draft.contact && draft.contact.phone_country_code);
      setFieldValue('phone', draft && draft.contact && draft.contact.phone_raw);
      setFieldValue('customer_id', draft && draft.contact && draft.contact.customer_id);
      setCheckboxValue('accepted_item_confirmation', draft && draft.accepted_item_confirmation);
      setCheckboxValue('accepted_terms', draft && draft.accepted_terms);

      activeStep = draft && draft.active_step ? draft.active_step : 'Intro';
      articlesContainer.innerHTML = '';
      draftImages.articles = {};
      imageProcessing.articles = {};
      imageErrors.articles = {};
      imageProcessingRuns.articles = {};

      if (!articles.length) {
        addArticleCard({}, {}, { open: true });
      } else {
        articles.forEach(function (articleData, index) {
          createArticleCard(index + 1, articleData, {}, {
            open: index === 0,
            saved: Boolean(articleData.saved)
          });
        });
      }

      articleNodes = Array.prototype.slice.call(articlesContainer.querySelectorAll('[data-ns-submission-article]'));

      articles.forEach(function (articleData, index) {
        var articleNode = articleNodes[index];
        var brandInput;
        var typeInput;

        if (!articleNode) {
          return;
        }

        brandInput = articleNode.querySelector('[data-ns-submission-brand]');
        typeInput = articleNode.querySelector('[data-ns-submission-type]');

        if (brandInput) {
          brandInput.value = articleData.brand || '';
          updateBrandStatus(brandInput);
        }

        if (typeInput) {
          typeInput.value = articleData.type || '';
          updateTypeStatus(typeInput);
        }

        if (articleNode.querySelector('[data-ns-submission-color]')) {
          articleNode.querySelector('[data-ns-submission-color]').value = articleData.color || '';
        }

        if (articleNode.querySelector('[data-ns-submission-size]')) {
          articleNode.querySelector('[data-ns-submission-size]').value = articleData.size || '';
        }

        if (articleNode.querySelector('[data-ns-submission-comment]')) {
          articleNode.querySelector('[data-ns-submission-comment]').value = articleData.comment || '';
        }
      });

      for (var i = 0; i < articleNodes.length; i += 1) {
        await restoreDraftImagesForArticle(articleNodes[i], i + 1);
      }

      updatePhonePreview();
      isRestoringDraft = false;
      updateStepAccordions();
      setDraftStatus('Utkast sparat');
    }

    function updateAllTypeStatuses() {
      Array.prototype.forEach.call(articlesContainer.querySelectorAll('[data-ns-submission-type]'), updateTypeStatus);
    }

    function validateStaticFields(articleCount) {
      if (!endpoint) {
        return 'Formulärets endpoint saknas.';
      }

      if (!form.elements.name.value.trim() || !form.elements.email.value.trim() || !form.elements.phone.value.trim()) {
        return 'Fyll i namn, e-post och telefonnummer.';
      }

      if (!isValidNormalizedPhone(getNormalizedPhone())) {
        return 'Telefonnumret ser inte giltigt ut. Kontrollera land och nummer.';
      }

      if (!articleCount || articleCount < 1 || articleCount > MAX_ARTICLES) {
        return 'Max 20 artiklar per registrering. Skapa en ny registrering för fler artiklar.';
      }

      if (!form.elements.accepted_item_confirmation.checked || !form.elements.accepted_terms.checked) {
        return 'Bekräfta varorna och acceptera villkoren.';
      }

      return '';
    }

    async function collectPayload() {
      var articleNodes = Array.prototype.slice.call(articlesContainer.querySelectorAll('[data-ns-submission-article]'));
      var articleCount = articleNodes.length;
      var staticError = validateStaticFields(articleCount);
      var articles = [];
      var totalBytes = 0;

      if (staticError) {
        throw new Error(staticError);
      }

      if (hasAnyImageProcessing()) {
        throw new Error('Vänta tills bilderna är klara.');
      }

      if (getFirstImageError()) {
        throw new Error(getFirstImageError());
      }

      for (var i = 0; i < articleNodes.length; i += 1) {
        var node = articleNodes[i];
        var index = Number(node.getAttribute('data-index'));
        var brand = node.querySelector('[data-ns-submission-brand]').value.trim();
        var brandStatus = getBrandStatus(brand);
        var typeInput = node.querySelector('[data-ns-submission-type]');
        var matchedType = getMatchedItemType(typeInput ? typeInput.value : '');
        var type = matchedType ? matchedType.name : safeText(typeInput && typeInput.value).trim();
        var color = node.querySelector('[data-ns-submission-color]').value.trim();
        var size = node.querySelector('[data-ns-submission-size]').value;
        var comment = node.querySelector('[data-ns-submission-comment]').value.trim();
        var imageFront;
        var imageLabel;
        var imageBack;
        var imageCareLabel;

        if (!brand || !type || !color || !size) {
          throw new Error('Fyll i varumärke, typ, färg och storlek för alla artiklar.');
        }

        if (node.getAttribute('data-saved') !== 'true') {
          throw new Error('Spara artikel ' + index + ' innan du skickar förhandsregistreringen.');
        }

        if (isBlockedBrandStatus(brandStatus)) {
          throw new Error('Det här varumärket tar vi inte emot via förhandsregistreringen.');
        }

        if (!matchedType) {
          throw new Error('Välj typ av vara från listan.');
        }

        imageFront = getDraftArticleImage(index, 'front');
        imageLabel = getDraftArticleImage(index, 'label');
        imageBack = getDraftArticleImage(index, 'back');
        imageCareLabel = getDraftArticleImage(index, 'care_label');

        if (!imageFront) {
          throw new Error('Ladda upp framsida för artikel ' + index + '.');
        }

        if (!imageLabel) {
          throw new Error('Ladda upp märkeslapp i nacken för artikel ' + index + '.');
        }

        [imageFront, imageLabel, imageBack, imageCareLabel].forEach(function (image) {
          if (image) {
            totalBytes += image.size;
          }
        });

        articles.push({
          index: index,
          brand: brand,
          brand_status: brandStatus,
          type: type,
          type_category: matchedType.category || '',
          type_status: 'matched',
          color: color,
          size: size,
          comment: comment,
          image_front: imageFront,
          image_label: imageLabel,
          image_back: imageBack,
          image_care_label: imageCareLabel
        });
      }

      if (totalBytes > MAX_TOTAL_BYTES) {
        throw new Error('Bilderna är totalt för stora. Max 15 MB gäller efter komprimering.');
      }

      return {
        type: 'submission_lead',
        submitted_at: new Date().toISOString(),
        name: form.elements.name.value.trim(),
        email: form.elements.email.value.trim(),
        phone_country_code: form.elements.phone_country_code.value,
        phone: getNormalizedPhone(),
        customer_id: form.elements.customer_id.value.trim(),
        article_count: articleCount,
        articles: articles,
        accepted_item_confirmation: form.elements.accepted_item_confirmation.checked,
        accepted_terms: form.elements.accepted_terms.checked
      };
    }

    function loadBrands() {
      if (!brandsUrl) {
        return;
      }

      fetch(brandsUrl, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          var entries = [];

          if (!data) {
            return;
          }

          ['approved', 'restricted', 'rejected'].forEach(function (status) {
            (Array.isArray(data[status]) ? data[status] : []).forEach(function (name) {
              var normalized = normalizeText(name);
              if (!normalized || brandLookup[normalized]) {
                return;
              }
              brandLookup[normalized] = { name: name, status: status };
              entries.push({
                name: name,
                normalized: normalized,
                status: status
              });
            });
          });

          entries.sort(function (a, b) {
            return a.name.localeCompare(b.name, 'sv');
          });
          brandEntries = entries;
        })
        .catch(function () {});
    }

    function loadItemTypes() {
      if (!itemTypesUrl) {
        return;
      }

      fetch(itemTypesUrl, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          var lookup = Object.create(null);
          var flattenedEntries = [];

          if (!data) {
            return;
          }

          if (Array.isArray(data.types)) {
            data.types.forEach(function (name) {
              var normalized = normalizeText(name);

              if (!normalized || lookup[normalized]) {
                return;
              }

              lookup[normalized] = true;
              flattenedEntries.push({
                name: name,
                normalized: normalized,
                category: ''
              });
            });
          }

          if (data.categories && typeof data.categories === 'object') {
            Object.keys(data.categories).forEach(function (category) {
              (Array.isArray(data.categories[category]) ? data.categories[category] : []).forEach(function (name) {
                var normalized = normalizeText(name);

                if (!normalized || lookup[normalized]) {
                  return;
                }

                lookup[normalized] = true;
                flattenedEntries.push({
                  name: name,
                  normalized: normalized,
                  category: category
                });
              });
            });
          }

          flattenedEntries.sort(function (a, b) {
            return a.name.localeCompare(b.name, 'sv');
          });

          itemTypeEntries = flattenedEntries;
          itemTypeLookup = Object.create(null);

          itemTypeEntries.forEach(function (entry) {
            itemTypeLookup[entry.normalized] = entry;
          });
          updateAllTypeStatuses();
        })
        .catch(function () {
          itemTypeEntries = [];
          itemTypeLookup = Object.create(null);
        });
    }

    if (addArticleButton) {
      addArticleButton.addEventListener('click', function (event) {
        var article = addArticleCard({}, {}, { open: true });

        event.preventDefault();

        if (article) {
          setStepOpen('articles', true);
          scrollToArticleCard(article);
          scheduleDraftSave();
        }
      });
    }

    [phoneCountryInput, phoneInput].forEach(function (input) {
      if (!input) {
        return;
      }

      input.addEventListener('input', function (event) {
        updatePhonePreview();
        activeStep = getCurrentStepLabel(event.currentTarget);
        updateStepAccordions();
        scheduleDraftSave();
      });
      input.addEventListener('change', function (event) {
        updatePhonePreview();
        activeStep = getCurrentStepLabel(event.currentTarget);
        updateStepAccordions();
        scheduleDraftSave();
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-ns-submission-step-save]'), function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        saveStep(button.getAttribute('data-ns-submission-step-save'));
      });
    });

    articlesContainer.addEventListener('click', function (event) {
      var saveButton = event.target.closest ? event.target.closest('[data-ns-submission-article-save]') : null;
      var removeButton = event.target.closest ? event.target.closest('[data-ns-submission-article-remove]') : null;
      var articleNode;
      var snapshots;

      if (!saveButton && !removeButton) {
        return;
      }

      event.preventDefault();
      articleNode = (saveButton || removeButton).closest('[data-ns-submission-article]');

      if (articleNode && saveButton) {
        saveArticleCard(articleNode);
        return;
      }

      if (!articleNode || !removeButton) {
        return;
      }

      if (articleHasData(articleNode) && !window.confirm('Ta bort artikeln? Ifyllda uppgifter och bilder för den här artikeln tas bort.')) {
        return;
      }

      snapshots = getArticleNodes()
        .filter(function (node) {
          return node !== articleNode;
        })
        .map(function (node) {
          return {
            data: getArticleFormData(node),
            images: getArticleImageSet(Number(node.getAttribute('data-index'))),
            open: node.open,
            saved: node.getAttribute('data-saved') === 'true'
          };
        });

      rebuildArticlesFromSnapshots(snapshots);
    });

    form.addEventListener('input', function (event) {
      activeStep = getCurrentStepLabel(event.target);
      setStepError(getCurrentStepKey(event.target), '');

      if (event.target.closest && event.target.closest('[data-ns-submission-article]')) {
        markArticleUnsaved(event.target.closest('[data-ns-submission-article]'));
        setArticleError(event.target.closest('[data-ns-submission-article]'), '');
      }

      updateStepAccordions();
      scheduleDraftSave();
    });

    form.addEventListener('change', function (event) {
      activeStep = getCurrentStepLabel(event.target);
      setStepError(getCurrentStepKey(event.target), '');

      if (event.target.closest && event.target.closest('[data-ns-submission-article]')) {
        markArticleUnsaved(event.target.closest('[data-ns-submission-article]'));
        setArticleError(event.target.closest('[data-ns-submission-article]'), '');
      }

      updateStepAccordions();
      scheduleDraftSave();
    });

    if (draftRestoreButton) {
      draftRestoreButton.addEventListener('click', function () {
        restoreDraft(getStoredDraft() || {});
      });
    }

    if (draftClearButton) {
      draftClearButton.addEventListener('click', function () {
        clearDraft().then(function () {
          setDraftPromptVisible(false);
          draftRestoreChoicePending = false;
          form.reset();
          articlesContainer.innerHTML = '';
          draftImages.articles = {};
          imageProcessing.articles = {};
          imageErrors.articles = {};
          imageProcessingRuns.articles = {};
          addArticleCard({}, {}, { open: true });
          updateStepAccordions();
        });
      });
    }

    stepNodes.forEach(function (stepNode) {
      stepNode.addEventListener('toggle', function () {
        if (stepNode.open) {
          activeStep = stepNode.getAttribute('data-step-label') || activeStep;
          scheduleDraftSave();
        }
      });
    });

    modalCloseNodes.forEach(function (closeNode) {
      closeNode.addEventListener('click', closeSubmissionModal);
    });

    if (successNewButton) {
      successNewButton.addEventListener('click', reloadCleanRegistrationPage);
    }

    if (successHomeButton) {
      successHomeButton.addEventListener('click', goToHomePage);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modalNode && !modalNode.hidden) {
        closeSubmissionModal();
      }
    });

    form.addEventListener('submit', async function (event) {
      var payload;
      var response;
      var responseText;
      var result;
      var endpointWarning;

      event.preventDefault();

      if (isSubmitting || hasSubmittedSuccessfully) {
        return;
      }

      setError('');
      setSuccess('');

      try {
        var estimate = getSubmitWorkloadEstimate();

        isSubmitting = true;
        setSubmitting(true);
        showSubmissionModal('loading', {
          title: 'Vi skickar din förfrågan',
          copy: 'Det kan ta en liten stund beroende på antal bilder och uppkoppling. Stäng inte sidan.',
          meta: estimate.text,
          next: 'Stäng inte sidan.'
        });
        startSubmitProgress();
        startSlowSubmitTimer();
        payload = await collectPayload();
        logDebug('before submit', buildPayloadDebugSummary(payload));
        response = await fetch(endpoint || DEFAULT_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'text/plain;charset=utf-8'
          },
          body: JSON.stringify(payload)
        });
        responseText = await response.text();

        try {
          result = responseText ? JSON.parse(responseText) : null;
        } catch (parseError) {
          result = null;
        }

        logDebug('response', {
          endpoint_url: endpoint || DEFAULT_ENDPOINT,
          ok: response.ok,
          status: response.status,
          response_body: responseText,
          result_status: result && result.status ? result.status : '',
          result_message: result && result.message ? result.message : '',
          case_number: result && (result.case_number || result.caseNumber) ? (result.case_number || result.caseNumber) : ''
        });

        endpointWarning = getEndpointWarning(result, responseText);

        if (endpointWarning) {
          warnDebug(endpointWarning, {
            endpoint_url: endpoint || DEFAULT_ENDPOINT,
            response_status: response.status,
            response_body: responseText
          });
        }

        if (!response.ok || !result || result.status !== 'ok') {
          throw new Error(getSubmissionErrorMessage(
            result,
            debugEnabled && endpointWarning ? endpointWarning : 'Förhandsregistreringen kunde inte skickas. Kontrollera uppgifterna och försök igen.'
          ));
        }

        var caseNumber = result.caseNumber || result.case_number || '';

        await clearDraft();

        completeSubmitProgress();
        hasSubmittedSuccessfully = true;
        form.reset();
        articlesContainer.innerHTML = '';
        setStepOpen('contact', true);
        setStepOpen('articles', false);
        setStepOpen('confirm', true);
        updateStepAccordions();
        setSuccess('Tack. Din förfrågan är mottagen och inväntar granskning. Vi återkommer när artiklarna är granskade.');
        showSubmissionModal('success', {
          title: 'Förfrågan mottagen',
          copy: 'Tack. Din förfrågan är mottagen och inväntar granskning. Vi återkommer när artiklarna är granskade.',
          meta: caseNumber ? 'Ärendenummer: ' + caseNumber : '',
          next: 'Du skickas vidare till startsidan om 20 sekunder.',
          actions: true
        });
        startSuccessRedirectCountdown();
      } catch (error) {
        var errorMessage = getSubmissionErrorMessage(null, error && error.message ? error.message : 'Förhandsregistreringen kunde inte skickas. Kontrollera uppgifterna och försök igen.');
        stopSubmitProgress();
        openStepForMessage(errorMessage);
        updateStepAccordions();
        setError(errorMessage);
        showSubmissionModal('error', {
          title: 'Förhandsregistreringen kunde inte skickas',
          copy: errorMessage || 'Kontrollera uppgifterna och försök igen. Om problemet kvarstår kan du kontakta oss.',
          next: 'Dina uppgifter och bilder ligger kvar i formuläret.'
        });
      } finally {
        stopSlowSubmitTimer();
        if (!hasSubmittedSuccessfully) {
          stopSubmitProgress();
        }
        isSubmitting = false;

        if (hasSubmittedSuccessfully) {
          setSubmitComplete();
        } else {
          setSubmitting(false);
        }
      }
    });

    loadBrands();
    loadItemTypes();
    updatePhonePreview();
    updateStepAccordions();

    if (getStoredDraft()) {
      draftRestoreChoicePending = true;
      setDraftPromptVisible(true);
    } else {
      addArticleCard({}, {}, { open: true });
    }

    draftSaveInterval = window.setInterval(saveDraftNow, DRAFT_SAVE_INTERVAL_MS);
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ns-submission-root]'), initForm);
  });
}());
